import { render, staticRenderFns } from "./next-steps-popup.vue?vue&type=template&id=8ee929fa&"
import script from "./next-steps-popup.vue?vue&type=script&lang=js&"
export * from "./next-steps-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ee929fa')) {
      api.createRecord('8ee929fa', component.options)
    } else {
      api.reload('8ee929fa', component.options)
    }
    module.hot.accept("./next-steps-popup.vue?vue&type=template&id=8ee929fa&", function () {
      api.rerender('8ee929fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/subcomponents/next-steps-popup.vue"
export default component.exports